import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Cancel20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_769)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C12.0081 1.75 13.8486 2.46746 15.2793 3.66002L3.66005 15.2793C2.46747 13.8487 1.75 12.0081 1.75 10ZM4.72071 16.34C6.15133 17.5325 7.99188 18.25 10 18.25C14.5563 18.25 18.25 14.5563 18.25 10C18.25 7.99186 17.5325 6.1513 16.3399 4.72067L4.72071 16.34Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_769'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Cancel20.displayName = 'Cancel20';
export default Cancel20;
